export default [{
  path: 'accountconfig/:leftid',
  name: 'merchant_accountconfig',
  component: () => import('@/views/merchant/setting/accountconfig/list'),
  meta: {
    tpflag: 'merchant',
    title: '账户信息',
  }
}, {
  path: 'merchantdetail/:leftid',
  name: 'merchant_merchantdetail',
  component: () => import('@/views/merchant/setting/accountconfig/merchant_detail'),
  meta: {
    tpflag: 'merchant',
    title: '企业信息修改',
  }
}, {
  path: 'accountdetail/:leftid',
  name: 'merchant_accountdetail',
  component: () => import('@/views/merchant/setting/accountconfig/account_detail'),
  meta: {
    tpflag: 'merchant',
    title: '成员信息修改',
  }
}]



// WEBPACK FOOTER //
// ./src/router/user/_accountconfig.js